import { useLocation } from 'react-router-dom';

const useCurrentSlug = () => {
    const location = useLocation();
    const pathSegments = location.pathname.split('/');
    
    // Assuming the slug is the last segment after the language and category
    // e.g., /es/category/my-slug -> my-slug
    return pathSegments[pathSegments.length - 1];
};

export default useCurrentSlug;
